import React from "react";
interface HeadingProps {
  title: string;
  description?: string;
}

export const Heading: React.FC<HeadingProps> = ({ title, description }) => {
  return (
    <div className="space-y-2">
      <h2 className="text-xl font-bold leading-8 tracking-tight text-grey-90 font-neutral-grotesk capitalize">
        {title}
      </h2>
      <p className="text-sm text-muted-foreground">{description}</p>
    </div>
  );
};
